export default __webpack_public_path__ + "static/media/DwarfCow01_Landscape.ff8c30d6.webp";